export class LoanChecklistsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async triggerOptionalChecklistRecalculation({ applicationId }) {
    // Loan-editor secondary write: this is a best-effort recalculation trigger for every user
    // (a subtree-scoped TPO broker is additionally not authorized to trigger it at all), so a
    // 403 here must always degrade the panel, not toast — unconditional, matching
    // applicationPricingStatusApi/channelApi (DEV-4226).
    return this.#http.put(`api/applications/${applicationId}/checklist-results/sync`, null, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }
}
